export function programSearchResults() {
    const programSearchWraps = document.querySelectorAll('.program-search-results');

    function hideItems(items) {
        items.forEach((item, index) => {
            if (index > 3) {
                item.classList.add('hidden');
            }
        });
    }

    function showItems(items) {
        items.forEach(item => {
            item.classList.remove('hidden');
        });
    }

    programSearchWraps.forEach(programSearchWrap => {
        const tables = programSearchWrap.querySelectorAll('table');

        tables.forEach(table => {
            const trArr = table.querySelectorAll('tbody tr');
            const thArr = table.querySelectorAll('th');

            trArr.forEach(tr => {
                const tdArr = tr.querySelectorAll('td');
                const lists = tr.querySelectorAll('ul');
                lists.forEach(list => {
                    const liArr = list.querySelectorAll('li');
                    hideItems(liArr);

                    if (liArr.length > 2 && list.classList.contains('semester-list')) {
                        list.insertAdjacentHTML('afterend', '<button class="link-more">View All</button>');
                    }

                });

                tdArr.forEach((cell, index) => {
                    if (thArr[index]) {
                        cell.setAttribute('data-label', thArr[index].textContent);
                    }
                });

                tr.addEventListener('click', function (e) {
                    const target = e.target;
                    const ulArr = target.closest('tr').querySelectorAll('ul');

                    if (target.tagName === 'BUTTON') {
                        if (!target.classList.contains('showed')) {
                            showItems(target.closest('tr').querySelectorAll('li'));
                            target.classList.add('showed');
                            target.innerText = 'hide Dates';
                        } else {
                            target.classList.remove('showed');
                            target.innerText = 'View All';
                            ulArr.forEach(ul => {
                                hideItems(ul.querySelectorAll('li'));
                            });
                        }
                    }
                })
            });
        });
        
    })
}


// WEBPACK FOOTER //
// ./assets/js/modules/programSearchResults.js